class HeaderSetting {
  init() {
    this.doc = document;
    this.dialog = this.doc.getElementById('settingDialog');
    this.backdrop = this.doc.getElementById('backdrop');
    this.activeClass = 'is_active';
    this.activeBackdropClass = 'is_active_transparent';
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.escape = this.escape.bind(this);
  }
  start() {
    this.btn = document.getElementById('settingBtn');
    if (!this.btn) return;
    this.init();
    this.btn.addEventListener('click', this.show);
  }
  show() {
    this.dialog.classList.add(this.activeClass);
    this.backdrop.classList.add(this.activeBackdropClass);
    this.backdrop.addEventListener('click', this.hide);
    this.btn.addEventListener('click', this.hide);
    this.doc.addEventListener('keydown', this.escape);
  }
  hide(e) {
    if (e) {
      e.stopPropagation();
    }
    this.dialog.classList.remove(this.activeClass);
    this.backdrop.classList.remove(this.activeBackdropClass);
    this.backdrop.removeEventListener('click', this.hide);
    this.btn.removeEventListener('click', this.hide);
    this.doc.removeEventListener('keydown', this.escape);
  }
  escape(e) {
    if (e.keyCode === 27) {
      this.hide();
    }
  }
}
export default HeaderSetting;



// WEBPACK FOOTER //
// ./src/js/module/HeaderSetting.js